import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ButtonPurple from 'components/design/Form/ButtonPurple'
import congratsImg from '@assets/images/common/congrats.png'
import customLanguageTexts from '../../../language'
import './index.css'

const ModalCongratulations = () => {
  const settings = useSelector(state => state.settings)
  const apps = useSelector(state => state.apps)
  const user = useSelector(state => state.user)
  const [readyToRenderPopup, setReadyToRenderPopup] = useState(false)
  const [isMultiTenantApp, setIsMultiTenantApp] = useState(false)
  const [hasHandledClose, setHasHandledClose] = useState(false)
  const [isAgentBuilderReady, setIsAgentBuilderReady] = useState(true)
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    if (settings.showModalConfetti) {
      setTimeout(() => {
        dispatch({
          type: 'settings/CHANGE_SETTING',
          payload: {
            setting: 'showModalConfetti',
            value: false,
          },
        })
      }, 6000)
    }
  }, [settings, dispatch])

  useEffect(() => {
    if (
      apps.active.id &&
      apps.active.planName &&
      user.id &&
      user.pooledBilling !== undefined &&
      user.pooledBilling
    ) {
      setIsMultiTenantApp(true)
      setReadyToRenderPopup(true)
    } else if (apps.active.id && apps.active.planName && user.id) {
      setIsMultiTenantApp(false)
      setReadyToRenderPopup(true)
    }
  }, [apps.active, user.id, user.pooledBilling])

  const modalID = 'congratulations'
  const visible = modalID === settings.visibleModalID
  useEffect(() => {
    if (visible) {
      setHasHandledClose(false)
      // Check if this is an AI agent creation flow
      const selectedFeatures = settings?.selectedFeaturesForGetStarted || []
      const isArray = Array.isArray(selectedFeatures)
      const hasAiAgent = isArray ? selectedFeatures.includes('aiAgent') : selectedFeatures === 'aiAgent'
      const hasChat = isArray ? (selectedFeatures.includes('chat') || selectedFeatures.includes('messaging')) : (selectedFeatures === 'chat' || selectedFeatures === 'messaging')
      
      if (hasAiAgent && !hasChat && apps.isAiAgentBuilderCreateFormLoading) {
        setIsAgentBuilderReady(false)
      } else {
        setIsAgentBuilderReady(true)
      }
    }
  }, [visible, settings, apps.isAiAgentBuilderCreateFormLoading])

  useEffect(() => {
    if (!isAgentBuilderReady && !apps.isAiAgentBuilderCreateFormLoading && apps.lastCreatedAgentId) {
      // Agent builder creation is complete
      setIsAgentBuilderReady(true)
    }
  }, [isAgentBuilderReady, apps.isAiAgentBuilderCreateFormLoading, apps.lastCreatedAgentId])

  const getButtonText = () => {
    if (!isAgentBuilderReady) {
      return "Preparing agent..."
    }
    if (apps.lastCreatedAgentId) {
      return "Go to agent"
    }
    return "Get Started"
  }

  const handleCancel = () => {
    if (hasHandledClose) return
    setHasHandledClose(true)
    if (settings?.nextRouteOnCongrats) {
      const next = settings.nextRouteOnCongrats
      console.log('[Congrats Modal] Navigating to next route from settings:', next)
      history.push(next)
      dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: { setting: 'nextRouteOnCongrats', value: '' },
      })
    } else if (apps?.lastCreatedAgentId) {
      const agentId = apps.lastCreatedAgentId
      const appId = apps.active?.id || apps.appCreated?.id
      if (appId && agentId) {
        const agentRoute = `/app/${appId}/ai-agents`
        history.push(agentRoute)
      }
    } else if (apps?.appCreated?.id) {
      const selected = settings?.selectedFeaturesForGetStarted || []
      const isArray = Array.isArray(selected)
      const hasChat = isArray ? (selected.includes('chat') || selected.includes('messaging')) : (selected === 'chat' || selected === 'messaging')
      const hasCalling = isArray ? (selected.includes('calling') || selected.includes('voice-and-calling')) : (selected === 'calling' || selected === 'voice-and-calling')
      const hasBYO = isArray ? (selected.includes('byo-agent') || selected.includes('moderation')) : (selected === 'byo-agent' || selected === 'moderation')
      let path = 'messaging-get-started'
      if (hasChat) {
        path = 'messaging-get-started'
      } else if (hasCalling) {
        path = 'calling-get-started'
      } else if (hasBYO) {
        path = 'byo-agent/get-started'
      }
      history.push(`/app/${apps.appCreated.id}/${path}`)
    }
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  let modalContent = (
    <div>
      <div>{customLanguageTexts.APP_CONGRATULATIONS_MODAL_TITLE}</div>
    </div>
  )
  if (isMultiTenantApp) {
    modalContent = <div>Congratulations! Your new app has been successfully created.</div>
  }
  return (
    <>
      <Modal
        className="custom__success__modal app__created__modal"
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>Your App Is Ready</span>
            <img
              src={congratsImg}
              alt="congrats"
              style={{ width: 24, height: 24 }}
            />
          </div>
        }
        onCancel={handleCancel}
        afterClose={() => {}}
        open={readyToRenderPopup && visible}
        footer={
          <div style={{ display: 'inline-flex' }}>
            <div style={{ maxWidth: '150px' }}>
              <ButtonPurple 
                buttonText={getButtonText()}
                buttonType="button" 
                onClick={handleCancel}
                disabled={!isAgentBuilderReady}
              />
            </div>
          </div>
        }
        maskClosable={false}
        style={{ padding: '0px' }}
      >
        <div className="p-0">{modalContent}</div>
      </Modal>
    </>
  )
}

export default ModalCongratulations
